module.exports = __webpack_public_path__ + "static/img/417_phase_function_Paper_PointsHejduk_Prediction.3a9a87c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/417_phase_function_Paper_PointsHejduk_Prediction.png
// module id = KzPx
// module chunks = 0